import React from 'react';
import ReactGA from 'react-ga';

import { Page } from '../components';
import { FormContent, PrimaryContent } from '../components/Content/HomeScreen';

ReactGA.pageview(window.location.pathname + window.location.search);

const HomeScreen = () => (
  <Page id="main">
    <PrimaryContent />
    <FormContent />
  </Page>
);

export default HomeScreen;
